import { MpxTypeaheadResult } from '@cibo/core'
import { MenuItem, ListItemText, Typography, Stack } from '@mui/material'
import { Markdown } from '@cibo/ui'

interface TypeaheadResultRowProps {
  suggestion: MpxTypeaheadResult
}

export const TypeaheadResultRow = ({
  suggestion: { type, label, resultInd, state, county },
  ...rest
}: TypeaheadResultRowProps) => {
  const displayLabel = label.replace(/\{\{/g, '**').replace(/\}\}/g, '**').replace('****', '')

  return (
    <MenuItem {...rest}>
      <ListItemText>
        <Stack>
          <Markdown>{displayLabel}</Markdown>
          {(county || state) && (
            <Typography variant="body2" color="text.secondary">
              {[county, state?.toUpperCase()].filter(Boolean).join(', ').replace(/[{}]/g, '')}
            </Typography>
          )}
        </Stack>
      </ListItemText>
    </MenuItem>
  )
}
